// components/SnackbarProvider.js
import React, { forwardRef } from "react";
import { SnackbarProvider } from "notistack";

const CustomSnackbarProvider = forwardRef(({ children }, ref) => (
  <SnackbarProvider
    anchorOrigin={{
      horizontal: "right",
      vertical: "top",
    }}
    maxSnack={3}
    ref={ref}
  >
    {children}
  </SnackbarProvider>
));

CustomSnackbarProvider.displayName = "CustomSnackbarProvider";

export default CustomSnackbarProvider;
